import { Component, Prop, State, h } from '@stencil/core';
import { getServiceNumber } from '../../utils/ttarp';
import { isBrowser } from '../../constants/constants';
import { trackAnalyticsEvent } from '../../utils/analytics';

const pushedEvents = new Set<string>();

@Component({
  tag: 'customer-contact',
  styleUrl: 'customer-contact.scss',
  shadow: true,
})
export class CustomerContact {
  @State() resolvedServiceNumber: string
  @Prop() serviceNumber: string;

  connectedCallback() {
    if (isBrowser) {
      this.pushDataLayerEvent();
    }
  }

  private async pushDataLayerEvent() {
    this.resolvedServiceNumber =
      this.serviceNumber ?? (await getServiceNumber());

    if (this.resolvedServiceNumber && !pushedEvents.has(this.resolvedServiceNumber)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ttarp_number_shown',
        ttarp_value: this.resolvedServiceNumber,
      });
      pushedEvents.add(this.resolvedServiceNumber);
    }
  }
  render() {
    return isBrowser && (
      <div class="ghf-customerContact--default">
        <div class="ghf-customerContact-help">
          <a
            class="ciHeader-phoneNumberLink"
            title="Customer Support Headset"
            href={`tel:${this.resolvedServiceNumber}`}
            data-section="ttarp"
            data-link="ttarp_link"
            onClick={trackAnalyticsEvent}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="ghf-customerContact-icon" >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22.5C10.8954 22.5 10 21.6046 10 20.5C10 19.3954 10.8954 18.5 12 18.5C12.7403 18.5 13.3866 18.9022 13.7324 19.5H16.0044C17.1036 19.5 18 18.6023 18 17.4973V9.49792C18 6.18687 15.3129 3.5 12 3.5C8.68569 3.5 6 6.18511 6 9.49792V15.0014C6 16.3812 4.87922 17.5 3.5 17.5C2.11947 17.5 1 16.3817 1 15.0014V11.9986C1 10.6188 2.12078 9.5 3.5 9.5H4C4 5.08045 7.58121 1.5 12 1.5C16.4175 1.5 20 5.08227 20 9.49792L20.5 9.5C21.8792 9.5 23 10.6188 23 11.9986V15.0014C23 16.3817 21.8805 17.5 20.5 17.5H20C19.9986 19.7077 18.208 21.5 16.0044 21.5H13.7324C13.3866 22.0978 12.7403 22.5 12 22.5ZM3.5 11.5C3.22458 11.5 3 11.7242 3 11.9986V15.0014C3 15.2766 3.22359 15.5 3.5 15.5C3.77542 15.5 4 15.2758 4 15.0014V11.5H3.5ZM21 15.0014V11.9986C21 11.7242 20.7754 11.5 20.5 11.5H20V15.5H20.5C20.7764 15.5 21 15.2766 21 15.0014Z" fill="var(--color-svg,#fa3c00)"/>
            </svg>
          </a>
          <span class="ghf-customerContact-helpText">Help</span>
        </div>
        <div class="ghf-customerContact-info">
          <span class="ghf-customerContact-text">Talk to a Real Person</span>
          <a
            class="ghf-customerContact-storeText ciHeader-phoneNumberLink"
            href={`tel:${this.resolvedServiceNumber}`}
            data-section="ttarp"
            data-link="ttarp_link"
            onClick={trackAnalyticsEvent}
          >
            {this.resolvedServiceNumber}
          </a>
        </div>
      </div>
    );
  }
}
